import type { OTCDealData } from '@src/types/OTC';
import { IconName } from '@talos/kyoko';
import type { MenuItemDef } from 'ag-grid-community';

export function viewDealScheduleMenuItem({
  deal,
  enabled,
  name,
  onViewSchedule,
}: {
  deal: Pick<OTCDealData, 'ID'> | undefined;
  enabled: boolean;
  name: string;
  onViewSchedule: (dealID: string) => void;
}): MenuItemDef | null {
  if (!enabled || deal?.ID == null) {
    return null;
  }

  const dealID = String(deal.ID);
  return {
    name,
    action: () => onViewSchedule(dealID),
    icon: `<i class="ag-icon ${IconName.Deepdive}"/>`,
  };
}
